module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title0":"Derivatives Market Announcements","title1":"Latest Market Announcements","title2":"Browse Older Announcements"},"ar":{"title0":"أخبار سوق المشتقات","title1":"أحدث إعلانات السوق","title2":"تصفح أخبار السوق القديمة"}}')
  delete Component.options._Ctor
}
